const packageJson = require('../../../../package.json');

const host = 'app-test.inase.uy';

export const environment = {
  appName: 'INASE - Registro de personas y empresas',
  envName: 'TEST',
  production: false,
  apiUrl: 'https://' + host + '/rpe/backend/api/v1', // cambiar luego la version y ponerla en los endpoints
  backendUrl: 'https://' + host + '/rpe/backend',
  hostBackend: host,
  apiIDE: 'https://direcciones.ide.uy/api/',
  test: true,
  i18nPrefix: '.',
  versions: {
    app: packageJson.version,
    angular: packageJson.dependencies['@angular/core'],
    ngrx: packageJson.dependencies['@ngrx/store'],
    material: packageJson.dependencies['@angular/material'],
    bootstrap: packageJson.dependencies.bootstrap,
    rxjs: packageJson.dependencies.rxjs,
    ngxtranslate: packageJson.dependencies['@ngx-translate/core'],
    fontAwesome:
      packageJson.dependencies['@fortawesome/fontawesome-free-webfonts'],
    angularCli: packageJson.devDependencies['@angular/cli'],
    typescript: packageJson.devDependencies['typescript'],
    cypress: packageJson.devDependencies['cypress'],
    eslint: packageJson.devDependencies['eslint']
  }
};
